/** Canonical form: `scrive` → `digital`, `none` → `parent`; absent → `digital`. */
export function normalizeSigningMode(mode) {
    if (mode === undefined || mode === 'scrive')
        return 'digital';
    if (mode === 'none')
        return 'parent';
    return mode;
}
/**
 * The legacy template lane's `signingMode` vocabulary for a mode, or
 * `null` for a bilaga that signs with its parent (the legacy lane leaves
 * `signingMode` unset there). `two_originals` is hand-signed, which the
 * legacy lane models as `manual_delivery`.
 */
export function legacySigningMode(mode) {
    switch (normalizeSigningMode(mode)) {
        case 'digital':
            return 'scrive';
        case 'manual_delivery':
        case 'two_originals':
            return 'manual_delivery';
        case 'export_only':
            return 'export_only';
        case 'parent':
            return null;
    }
}
export const attachmentSlotId = (slot) => (slot.id ?? slot.key);
export const signingSlots = (meta) => (meta?.partySlots ?? []).filter((slot) => slot.signs !== false);
/** The label a party slot's signature panel prints: `signingLabel`, else `label`. */
export const signingLabelFor = (slot) => slot.signingLabel ?? slot.label;
//# sourceMappingURL=meta.js.map